import { IAddress, IBusinessAddress, IJwtPayload, IPhoneNumberParts } from '@zeta-types';

export function separatePhoneNumber(phone: string): IPhoneNumberParts {
  const cleanedPhone = phone.replace(/\D/g, '');

  const countryCodeLength = cleanedPhone.length > 10 ? cleanedPhone.length - 10 : 0;

  const countryCode = cleanedPhone.substring(0, countryCodeLength);
  const phoneNumber = cleanedPhone.substring(countryCodeLength);

  return {
    countryCode: countryCode || 'Unknown',
    phoneNumber: phoneNumber || 'Invalid',
  };
}

export function jwtDecode(token: string | null): IJwtPayload | null {
  try {
    if (!token) return null;

    const parts = token.split('.');
    if (parts.length < 2) {
      throw new Error('Invalid token!');
    }

    const base64Url = parts[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const decoded = JSON.parse(atob(base64));

    return decoded;
  } catch (error) {
    console.error('Error decoding token:', error);
    throw error;
  }
}

export const combineAddress = (address: IAddress | IBusinessAddress | any): string => {
  const { addressLine1, addressLine2, addressLine3, addressLine4, city, county, country, postcode } = address;

  const addressParts = [addressLine1, addressLine2, addressLine3, addressLine4, city, county, country, postcode].filter((part) => part?.trim() !== '');

  return addressParts.join(', ');
};

export function combineNames(firstName: string, middleName: string | undefined, lastName: string | undefined): string {
  return `${firstName} ${middleName ? middleName + ' ' : ''}${lastName}`.trim();
}

export function parseFullNameString(fullName: string) {
  let firstName = '';
  let middleName = '';
  let lastName = '';
  const nameArr = fullName?.split(' ') || [];

  if (nameArr?.length === 1) {
    firstName = nameArr[0];
  } else if (nameArr?.length > 1) {
    firstName = nameArr[0];
    lastName = nameArr[nameArr.length - 1];
    if (nameArr?.length > 2) {
      middleName = nameArr.slice(1, nameArr.length - 1).join(' ');
    }
  }
  return { firstName, middleName, lastName };
}

export const getInitial = (fullName: string) => {
  const { firstName, lastName } = parseFullNameString(fullName || '');
  return `${firstName && firstName[0]}${lastName && lastName[0]}`;
};

export const truncateText = (text: string, charLimit: number) => {
  if (text?.length > charLimit) {
    return text?.slice(0, charLimit) + '...';
  }
  return text;
};

export function maskPhoneNumber(countryCode: string, phoneNumber: string): string {
  // Ensure countryCode is a valid string
  const validCountryCode = countryCode?.phone || '';
  // Validate phoneNumber and handle cases where it is undefined or too short
  if (!phoneNumber || phoneNumber.length < 4) {
    return `+${validCountryCode} ${phoneNumber || ''}`;
  }
  const firstTwo = phoneNumber.slice(0, 2);
  const lastTwo = phoneNumber.slice(-2);
  const maskedMiddle = 'X'.repeat(phoneNumber.length - 4); // Replace all middle digits with X
  return `+${validCountryCode} ${firstTwo}${maskedMiddle}${lastTwo}`;
}
